import { render, staticRenderFns } from "./DialogComplete.vue?vue&type=template&id=ba248256"
import script from "./DialogComplete.vue?vue&type=script&lang=js"
export * from "./DialogComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports